import { Route } from 'react-router-dom'
import { ProfilePage } from './pages/ProfilePage'

export const profileRoutes = (
    <Route index element={<ProfilePage />} />
)